import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/authStore";
import { ROUTES } from "@/constants/routes";
import { PageSpinner } from "@/components/ui/spinner";

export function AuthLayout() {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuthStore();
  const from =
    (location.state as { from?: { pathname: string } })?.from?.pathname ||
    ROUTES.DASHBOARD;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <PageSpinner message="Loading..." />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left side - Form */}
      <div className="flex items-center justify-center px-4 py-12 lg:px-8">
        <div className="w-full max-w-sm space-y-8">
          {/* Logo */}
          <div className="flex flex-col items-center">
            <img
              src="/zipto-logo.png"
              alt="BOOKFLEET Logo"
              className="h-20 w-20 object-contain"
            />
            <h1 className="mt-4 text-2xl font-bold">BOOKFLEET Admin</h1>
            <p className="text-muted-foreground">
              Logistics Management Platform
            </p>
          </div>

          {/* Outlet for login/forgot password forms */}
          <Outlet />
        </div>
      </div>

      {/* Right side - Branding */}
      <div className="hidden lg:flex flex-col justify-center bg-primary p-12 text-primary-foreground">
        <div className="space-y-6">
          <h2 className="text-4xl font-bold leading-tight">
            Manage your logistics operations with ease
          </h2>
          <p className="text-lg opacity-90">
            Monitor bookings, manage drivers, track payments, and analyze
            performance all in one powerful dashboard.
          </p>

          <div className="grid grid-cols-2 gap-6 pt-8">
            <div className="space-y-2">
              <div className="text-3xl font-bold">10K+</div>
              <div className="text-sm opacity-80">Daily Deliveries</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl font-bold">500+</div>
              <div className="text-sm opacity-80">Active Drivers</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl font-bold">50K+</div>
              <div className="text-sm opacity-80">Happy Customers</div>
            </div>
            <div className="space-y-2">
              <div className="text-3xl font-bold">4</div>
              <div className="text-sm opacity-80">Cities Covered</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
